import { Component } from '@angular/core';

@Component({
    selector: 'footer',
    templateUrl: './footer.html',
    styleUrls: ['./footer.css'],
    standalone: true,
})
export class FooterComponent {
    currYear: number = 0;
    constructor() {
        this.currYear = new Date().getFullYear();
    }
}
